// extracted by mini-css-extract-plugin
export default {"wrapper":"PlacesAutocompleteInput_wrapper__rhjJU","suggestionsList":"PlacesAutocompleteInput_suggestionsList__lcjNd","suggestionItem":"PlacesAutocompleteInput_suggestionItem__GcpQ0"};